import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { ShipmentVarietySize } from '../model/ShipmentVarietySize';

@Injectable()
export class ShipmentVarietySizeFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetByDeliveryCode(deliveryCode, organizationId = null): Observable<RequestResponse<[ShipmentVarietySize]>> {
        if (organizationId == null) {
            return this._httpClient.get<RequestResponse<[ShipmentVarietySize]>>(
                this._urlBase + 'api/ShipmentVarietySize?deliveryCode=' + deliveryCode
            );
        } else {
            return this._httpClient.get<RequestResponse<[ShipmentVarietySize]>>(this._urlBase + 'api/ShipmentVarietySize?deliveryCode='
            + deliveryCode + '&organizationId=' + organizationId);
        }
    }
}
